import { TermsResponseDto } from '@core/api/generated/accounts/v1';
import { createAction, props } from '@ngrx/store';

export const loadLegalTerms = createAction('[Legal] Load Terms');
export const loadLegalTermsSuccess = createAction('[Legal] Load Terms Success', props<{ terms: TermsResponseDto }>());
